export default "__VITE_ASSET__BK4Arhp8__"